(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("d3"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "d3", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ReactD3"] = factory(require("React"), require("d3"), require("ReactDOM"));
	else
		root["ReactD3"] = factory(root["React"], root["d3"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_24__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.d3 = exports.Brush = exports.AreaChart = exports.LineChart = exports.ScatterPlot = exports.PieChart = exports.Waveform = exports.BarChart = undefined;
	
	var _BarChart = __webpack_require__(26);
	
	Object.defineProperty(exports, 'BarChart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarChart).default;
	  }
	});
	
	var _Waveform = __webpack_require__(31);
	
	Object.defineProperty(exports, 'Waveform', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Waveform).default;
	  }
	});
	
	var _PieChart = __webpack_require__(29);
	
	Object.defineProperty(exports, 'PieChart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PieChart).default;
	  }
	});
	
	var _ScatterPlot = __webpack_require__(30);
	
	Object.defineProperty(exports, 'ScatterPlot', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScatterPlot).default;
	  }
	});
	
	var _LineChart = __webpack_require__(28);
	
	Object.defineProperty(exports, 'LineChart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineChart).default;
	  }
	});
	
	var _AreaChart = __webpack_require__(25);
	
	Object.defineProperty(exports, 'AreaChart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaChart).default;
	  }
	});
	
	var _Brush = __webpack_require__(27);
	
	Object.defineProperty(exports, 'Brush', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Brush).default;
	  }
	});
	
	var _d2 = __webpack_require__(4);
	
	var _d3 = _interopRequireDefault(_d2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.d3 = _d3.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(36)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(35)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(32);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var number = _propTypes2.default.number,
	    shape = _propTypes2.default.shape;
	
	
	var Chart = (0, _createReactClass2.default)({
	    displayName: 'Chart',
	
	    propTypes: {
	        height: number.isRequired,
	        width: number.isRequired,
	        margin: shape({
	            top: number,
	            bottom: number,
	            left: number,
	            right: number
	        }).isRequired
	    },
	
	    render: function render() {
	        var _props = this.props,
	            width = _props.width,
	            height = _props.height,
	            margin = _props.margin,
	            viewBox = _props.viewBox,
	            preserveAspectRatio = _props.preserveAspectRatio,
	            children = _props.children;
	
	
	        return _react2.default.createElement(
	            'svg',
	            { ref: 'svg', width: width, height: height, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + margin.left + ', ' + margin.top + ')' },
	                children
	            )
	        );
	    }
	});
	
	exports.default = Chart;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HeightWidthMixin = {
	    componentWillMount: function componentWillMount() {
	        this._calculateInner(this.props);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._calculateInner(nextProps);
	    },
	    _calculateInner: function _calculateInner(props) {
	        var height = props.height,
	            width = props.width,
	            margin = props.margin;
	
	
	        this._innerHeight = height - margin.top - margin.bottom;
	        this._innerWidth = width - margin.left - margin.right;
	    }
	};
	
	exports.default = HeightWidthMixin;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d = __webpack_require__(4);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneOfType = _propTypes2.default.oneOfType,
	    object = _propTypes2.default.object,
	    array = _propTypes2.default.array,
	    shape = _propTypes2.default.shape,
	    func = _propTypes2.default.func,
	    number = _propTypes2.default.number;
	
	
	var DefaultPropsMixin = {
	    propTypes: {
	        data: oneOfType([object, array]).isRequired,
	        height: number.isRequired,
	        width: number.isRequired,
	        margin: shape({
	            top: number,
	            bottom: number,
	            left: number,
	            right: number
	        }),
	        xScale: func,
	        yScale: func,
	        colorScale: func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            data: { label: 'No data available', values: [{ x: 'No data available', y: 1 }] },
	            margin: { top: 0, bottom: 0, left: 0, right: 0 },
	            xScale: null,
	            yScale: null,
	            colorScale: _d2.default.scale.category20()
	        };
	    }
	};
	
	exports.default = DefaultPropsMixin;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(24);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _propTypes2.default.func,
	    oneOf = _propTypes2.default.oneOf,
	    bool = _propTypes2.default.bool,
	    objectOf = _propTypes2.default.objectOf,
	    number = _propTypes2.default.number;
	
	
	var TooltipMixin = {
	    propTypes: {
	        tooltipHtml: func,
	        tooltipMode: oneOf(['mouse', 'element', 'fixed']),
	        tooltipContained: bool,
	        tooltipOffset: objectOf(number)
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            tooltip: {
	                hidden: true
	            }
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            tooltipMode: 'mouse',
	            tooltipOffset: { top: -35, left: 0 },
	            tooltipHtml: null,
	            tooltipContained: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this._svgNode = _reactDom2.default.findDOMNode(this).getElementsByTagName('svg')[0];
	    },
	    onMouseEnter: function onMouseEnter(e, data) {
	        if (!this.props.tooltipHtml) {
	            return;
	        }
	
	        e.preventDefault();
	
	        var _props = this.props,
	            margin = _props.margin,
	            tooltipMode = _props.tooltipMode,
	            tooltipOffset = _props.tooltipOffset,
	            tooltipContained = _props.tooltipContained;
	
	
	        var svg = this._svgNode;
	        var position = void 0;
	        if (svg.createSVGPoint) {
	            var point = svg.createSVGPoint();
	            point.x = e.clientX, point.y = e.clientY;
	            point = point.matrixTransform(svg.getScreenCTM().inverse());
	            position = [point.x - margin.left, point.y - margin.top];
	        } else {
	            var rect = svg.getBoundingClientRect();
	            position = [e.clientX - rect.left - svg.clientLeft - margin.left, e.clientY - rect.top - svg.clientTop - margin.top];
	        }
	
	        var _tooltipHtml = this._tooltipHtml(data, position),
	            _tooltipHtml2 = _slicedToArray(_tooltipHtml, 3),
	            html = _tooltipHtml2[0],
	            xPos = _tooltipHtml2[1],
	            yPos = _tooltipHtml2[2];
	
	        var svgTop = svg.getBoundingClientRect().top + margin.top;
	        var svgLeft = svg.getBoundingClientRect().left + margin.left;
	
	        var top = 0;
	        var left = 0;
	
	        if (tooltipMode === 'fixed') {
	            top = svgTop + tooltipOffset.top;
	            left = svgLeft + tooltipOffset.left;
	        } else if (tooltipMode === 'element') {
	            top = svgTop + yPos + tooltipOffset.top;
	            left = svgLeft + xPos + tooltipOffset.left;
	        } else {
	            // mouse
	            top = e.clientY + tooltipOffset.top;
	            left = e.clientX + tooltipOffset.left;
	        }
	
	        function lerp(t, a, b) {
	            return (1 - t) * a + t * b;
	        }
	
	        var translate = 50;
	
	        if (tooltipContained) {
	            var t = position[0] / svg.getBoundingClientRect().width;
	            translate = lerp(t, 0, 100);
	        }
	
	        this.setState({
	            tooltip: {
	                top: top,
	                left: left,
	                hidden: false,
	                html: html,
	                translate: translate
	            }
	        });
	    },
	    onMouseLeave: function onMouseLeave(e) {
	        if (!this.props.tooltipHtml) {
	            return;
	        }
	
	        e.preventDefault();
	
	        this.setState({
	            tooltip: {
	                hidden: true
	            }
	        });
	    }
	};
	
	exports.default = TooltipMixin;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ArrayifyMixin = {
	    componentWillMount: function componentWillMount() {
	        this._arrayify(this.props);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._arrayify(nextProps);
	    },
	    _arrayify: function _arrayify(props) {
	        if (props.data === null) {
	            this._data = [{
	                label: 'No data available',
	                values: [{ x: 'No data available', y: 1 }]
	            }];
	        } else if (!Array.isArray(props.data)) {
	            this._data = [props.data];
	        } else {
	            this._data = props.data;
	        }
	    }
	};
	
	exports.default = ArrayifyMixin;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var array = _propTypes2.default.array,
	    func = _propTypes2.default.func,
	    oneOf = _propTypes2.default.oneOf,
	    number = _propTypes2.default.number,
	    string = _propTypes2.default.string;
	
	
	var Axis = (0, _createReactClass2.default)({
	    displayName: 'Axis',
	
	    propTypes: {
	        tickArguments: array,
	        tickValues: array,
	        tickFormat: func,
	        tickDirection: oneOf(['horizontal', 'vertical', 'diagonal']),
	        innerTickSize: number,
	        tickPadding: number,
	        outerTickSize: number,
	        scale: func.isRequired,
	        className: string,
	        zero: number,
	        orientation: oneOf(['top', 'bottom', 'left', 'right']).isRequired,
	        label: string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            tickArguments: [10],
	            tickValues: null,
	            tickFormat: null,
	            tickDirection: 'horizontal',
	            innerTickSize: 6,
	            tickPadding: 3,
	            outerTickSize: 6,
	            className: 'axis',
	            zero: 0,
	            label: ''
	        };
	    },
	    _getTranslateString: function _getTranslateString() {
	        var _props = this.props,
	            orientation = _props.orientation,
	            height = _props.height,
	            width = _props.width,
	            zero = _props.zero;
	
	
	        if (orientation === 'top') {
	            return 'translate(0, ' + zero + ')';
	        } else if (orientation === 'bottom') {
	            return 'translate(0, ' + (zero == 0 ? height : zero) + ')';
	        } else if (orientation === 'left') {
	            return 'translate(' + zero + ', 0)';
	        } else if (orientation === 'right') {
	            return 'translate(' + (zero == 0 ? width : zero) + ', 0)';
	        } else {
	            return '';
	        }
	    },
	    render: function render() {
	        var _props2 = this.props,
	            height = _props2.height,
	            tickArguments = _props2.tickArguments,
	            tickValues = _props2.tickValues,
	            tickDirection = _props2.tickDirection,
	            innerTickSize = _props2.innerTickSize,
	            tickPadding = _props2.tickPadding,
	            outerTickSize = _props2.outerTickSize,
	            scale = _props2.scale,
	            orientation = _props2.orientation,
	            zero = _props2.zero;
	        var _props3 = this.props,
	            width = _props3.width,
	            className = _props3.className,
	            label = _props3.label;
	        var tickFormat = this.props.tickFormat;
	
	
	        var ticks = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues;
	
	        if (!tickFormat) {
	            if (scale.tickFormat) {
	                tickFormat = scale.tickFormat.apply(scale, tickArguments);
	            } else {
	                tickFormat = function tickFormat(x) {
	                    return x;
	                };
	            }
	        }
	
	        // TODO: is there a cleaner way? removes the 0 tick if axes are crossing
	        if (zero != height && zero != width && zero != 0) {
	            ticks = ticks.filter(function (element) {
	                return element != 0;
	            });
	        }
	
	        var tickSpacing = Math.max(innerTickSize, 0) + tickPadding;
	
	        var sign = orientation === 'top' || orientation === 'left' ? -1 : 1;
	
	        var range = this._d3ScaleRange(scale);
	
	        var activeScale = scale.rangeBand ? function (e) {
	            return scale(e) + scale.rangeBand() / 2;
	        } : scale;
	
	        var transform = void 0,
	            x = void 0,
	            y = void 0,
	            x2 = void 0,
	            y2 = void 0,
	            dy = void 0,
	            textAnchor = void 0,
	            d = void 0,
	            labelElement = void 0,
	            tickRotation = 0;
	        if (orientation === 'bottom' || orientation === 'top') {
	            transform = 'translate({}, 0)';
	            x = 0;
	            y = sign * tickSpacing;
	            x2 = 0;
	            y2 = sign * innerTickSize;
	            dy = sign < 0 ? '0em' : '.71em';
	            textAnchor = 'middle';
	            d = 'M' + range[0] + ', ' + sign * outerTickSize + 'V0H' + range[1] + 'V' + sign * outerTickSize;
	            if (tickDirection === 'vertical') {
	                tickRotation = -90;
	                x = -tickSpacing;
	                y = -innerTickSize;
	                textAnchor = 'end';
	            } else if (tickDirection === 'diagonal') {
	                tickRotation = -60;
	                x = -tickSpacing;
	                y = 0;
	                textAnchor = 'end';
	            }
	
	            labelElement = _react2.default.createElement(
	                'text',
	                { className: className + ' label', textAnchor: "end", x: width, y: -6 },
	                label
	            );
	        } else {
	            transform = 'translate(0, {})';
	            x = sign * tickSpacing;
	            y = 0;
	            x2 = sign * innerTickSize;
	            y2 = 0;
	            dy = '.32em';
	            textAnchor = sign < 0 ? 'end' : 'start';
	            d = 'M' + sign * outerTickSize + ', ' + range[0] + 'H0V' + range[1] + 'H' + sign * outerTickSize;
	            if (tickDirection === 'vertical') {
	                tickRotation = -90;
	                x -= sign * tickSpacing;
	                y = -(tickSpacing + innerTickSize);
	                textAnchor = 'middle';
	            } else if (tickDirection === 'diagonal') {
	                tickRotation = -60;
	                x -= sign * tickSpacing;
	                y = -(tickSpacing + innerTickSize);
	                textAnchor = 'middle';
	            }
	
	            labelElement = _react2.default.createElement(
	                'text',
	                { className: className + ' label', textAnchor: 'end', y: 6, dy: orientation === 'left' ? '.75em' : '-1.25em', transform: 'rotate(-90)' },
	                label
	            );
	        }
	
	        var tickElements = ticks.map(function (tick, index) {
	            var position = activeScale(tick);
	            var translate = transform.replace('{}', position);
	            return _react2.default.createElement(
	                'g',
	                { key: tick + '.' + index, className: 'tick', transform: translate },
	                _react2.default.createElement('line', { x2: x2, y2: y2, stroke: '#aaa' }),
	                _react2.default.createElement(
	                    'text',
	                    { x: x, y: y, dy: dy, textAnchor: textAnchor, transform: 'rotate(' + tickRotation + ')' },
	                    tickFormat(tick)
	                )
	            );
	        });
	
	        var pathElement = _react2.default.createElement('path', { className: 'domain', d: d, fill: 'none', stroke: '#aaa' });
	
	        var axisBackground = _react2.default.createElement('rect', { className: 'axis-background', fill: 'none' });
	
	        return _react2.default.createElement(
	            'g',
	            { ref: 'axis', className: className, transform: this._getTranslateString(), style: { shapeRendering: 'crispEdges' } },
	            axisBackground,
	            tickElements,
	            pathElement,
	            labelElement
	        );
	    },
	    _d3ScaleExtent: function _d3ScaleExtent(domain) {
	        var start = domain[0];
	        var stop = domain[domain.length - 1];
	        return start < stop ? [start, stop] : [stop, start];
	    },
	    _d3ScaleRange: function _d3ScaleRange(scale) {
	        return scale.rangeExtent ? scale.rangeExtent() : this._d3ScaleExtent(scale.range());
	    }
	});
	
	exports.default = Axis;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d2 = __webpack_require__(4);
	
	var _d3 = _interopRequireDefault(_d2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var number = _propTypes2.default.number;
	
	
	var DefaultScalesMixin = {
	    propTypes: {
	        barPadding: number
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            barPadding: 0.5
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        this._makeScales(this.props);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._makeScales(nextProps);
	    },
	    _makeScales: function _makeScales(props) {
	        var xScale = props.xScale,
	            xIntercept = props.xIntercept,
	            yScale = props.yScale,
	            yIntercept = props.yIntercept;
	
	
	        if (!xScale) {
	            var _makeXScale = this._makeXScale(props);
	
	            var _makeXScale2 = _slicedToArray(_makeXScale, 2);
	
	            this._xScale = _makeXScale2[0];
	            this._xIntercept = _makeXScale2[1];
	        } else {
	            var _ref = [xScale, xIntercept];
	            this._xScale = _ref[0];
	            this._xIntercept = _ref[1];
	        }
	
	        if (!yScale) {
	            var _makeYScale = this._makeYScale(props);
	
	            var _makeYScale2 = _slicedToArray(_makeYScale, 2);
	
	            this._yScale = _makeYScale2[0];
	            this._yIntercept = _makeYScale2[1];
	        } else {
	            var _ref2 = [yScale, yIntercept];
	            this._yScale = _ref2[0];
	            this._yIntercept = _ref2[1];
	        }
	    },
	    _makeXScale: function _makeXScale(props) {
	        var x = props.x,
	            values = props.values;
	
	        var data = this._data;
	
	        if (typeof x(values(data[0])[0]) === 'number') {
	            return this._makeLinearXScale(props);
	        } else if (typeof x(values(data[0])[0]).getMonth === 'function') {
	            return this._makeTimeXScale(props);
	        } else {
	            return this._makeOrdinalXScale(props);
	        }
	    },
	    _makeLinearXScale: function _makeLinearXScale(props) {
	        var x = props.x,
	            values = props.values;
	
	        var data = this._data;
	
	        var extentsData = data.map(function (stack) {
	            return values(stack).map(function (e) {
	                return x(e);
	            });
	        });
	        var extents = _d3.default.extent(Array.prototype.concat.apply([], extentsData));
	
	        var scale = _d3.default.scale.linear().domain(extents).range([0, this._innerWidth]);
	
	        var zero = _d3.default.max([0, scale.domain()[0]]);
	        var xIntercept = scale(zero);
	
	        return [scale, xIntercept];
	    },
	    _makeOrdinalXScale: function _makeOrdinalXScale(props) {
	        var x = props.x,
	            values = props.values,
	            barPadding = props.barPadding;
	
	
	        var scale = _d3.default.scale.ordinal().domain(values(this._data[0]).map(function (e) {
	            return x(e);
	        })).rangeRoundBands([0, this._innerWidth], barPadding);
	
	        return [scale, 0];
	    },
	    _makeTimeXScale: function _makeTimeXScale(props) {
	        var x = props.x,
	            values = props.values;
	
	
	        var minDate = _d3.default.min(values(this._data[0]), x);
	        var maxDate = _d3.default.max(values(this._data[0]), x);
	
	        var scale = _d3.default.time.scale().domain([minDate, maxDate]).range([0, this._innerWidth]);
	
	        return [scale, 0];
	    },
	    _makeYScale: function _makeYScale(props) {
	        var y = props.y,
	            values = props.values;
	
	        var data = this._data;
	
	        if (typeof y(values(data[0])[0]) === 'number') {
	            return this._makeLinearYScale(props);
	        } else {
	            return this._makeOrdinalYScale(props);
	        }
	    },
	    _makeLinearYScale: function _makeLinearYScale(props) {
	        var y = props.y,
	            y0 = props.y0,
	            values = props.values,
	            groupedBars = props.groupedBars;
	
	
	        var extentsData = this._data.map(function (stack) {
	            return values(stack).map(function (e) {
	                return groupedBars ? y(e) : y0(e) + y(e);
	            });
	        });
	        var extents = _d3.default.extent(Array.prototype.concat.apply([], extentsData));
	
	        extents = [_d3.default.min([0, extents[0]]), extents[1]];
	
	        var scale = _d3.default.scale.linear().domain(extents).range([this._innerHeight, 0]);
	
	        var zero = _d3.default.max([0, scale.domain()[0]]);
	        var yIntercept = scale(zero);
	
	        return [scale, yIntercept];
	    },
	    _makeOrdinalYScale: function _makeOrdinalYScale() {
	        var scale = _d3.default.scale.ordinal().range([this._innerHeight, 0]);
	
	        var yIntercept = scale(0);
	
	        return [scale, yIntercept];
	    }
	};
	
	exports.default = DefaultScalesMixin;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var number = _propTypes2.default.number,
	    node = _propTypes2.default.node;
	
	
	var Tooltip = (0, _createReactClass2.default)({
	    displayName: 'Tooltip',
	
	    propTypes: {
	        top: number.isRequired,
	        left: number.isRequired,
	        html: node,
	        translate: number
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            top: 150,
	            left: 100,
	            html: '',
	            translate: 50
	        };
	    },
	    render: function render() {
	        var _props = this.props,
	            top = _props.top,
	            left = _props.left,
	            hidden = _props.hidden,
	            html = _props.html,
	            translate = _props.translate;
	
	
	        var style = {
	            display: hidden ? 'none' : 'block',
	            position: 'fixed',
	            top: top,
	            left: left,
	            transform: 'translate(-' + translate + '%, 0)',
	            pointerEvents: 'none'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'tooltip', style: style },
	            html
	        );
	    }
	});
	
	exports.default = Tooltip;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _propTypes2.default.func;
	
	
	var AccessorMixin = {
	    propTypes: {
	        label: func,
	        values: func,
	        x: func,
	        y: func,
	        y0: func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            label: function label(stack) {
	                return stack.label;
	            },
	            values: function values(stack) {
	                return stack.values;
	            },
	            x: function x(e) {
	                return e.x;
	            },
	            y: function y(e) {
	                return e.y;
	            },
	            y0: function y0() {
	                return 0;
	            }
	        };
	    }
	};
	
	exports.default = AccessorMixin;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _propTypes2.default.func;
	
	
	var StackAccessorMixin = {
	    propTypes: {
	        label: func,
	        values: func,
	        x: func,
	        y: func,
	        y0: func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            label: function label(stack) {
	                return stack.label;
	            },
	            values: function values(stack) {
	                return stack.values;
	            },
	            x: function x(e) {
	                return e.x;
	            },
	            y: function y(e) {
	                return e.y;
	            },
	            y0: function y0(e) {
	                return e.y0;
	            }
	        };
	    }
	};
	
	exports.default = StackAccessorMixin;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d = __webpack_require__(4);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var string = _propTypes2.default.string;
	
	
	var StackDataMixin = {
	    propTypes: {
	        offset: string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            offset: 'zero',
	            order: 'default'
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        this._stackData(this.props);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._stackData(nextProps);
	    },
	    _stackData: function _stackData(props) {
	        var offset = props.offset,
	            order = props.order,
	            x = props.x,
	            y = props.y,
	            values = props.values;
	
	
	        var stack = _d2.default.layout.stack().offset(offset).order(order).x(x).y(y).values(values);
	
	        this._data = stack(this._data);
	
	        for (var m = 0; m < values(this._data[0]).length; m++) {
	            var positiveBase = 0;
	            var negativeBase = 0;
	            for (var n = 0; n < this._data.length; n++) {
	                var value = y(values(this._data[n])[m]);
	                if (value < 0) {
	                    values(this._data[n])[m].y0 = negativeBase;
	                    negativeBase += value;
	                } else {
	                    values(this._data[n])[m].y0 = positiveBase;
	                    positiveBase += value;
	                }
	            }
	        }
	    }
	};
	
	exports.default = StackDataMixin;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var number = _propTypes2.default.number,
	    string = _propTypes2.default.string,
	    array = _propTypes2.default.array,
	    object = _propTypes2.default.object,
	    func = _propTypes2.default.func,
	    oneOfType = _propTypes2.default.oneOfType;
	
	
	var Bar = (0, _createReactClass2.default)({
	    displayName: 'Bar',
	
	    propTypes: {
	        width: number.isRequired,
	        height: number.isRequired,
	        x: number.isRequired,
	        y: number.isRequired,
	        fill: string.isRequired,
	        data: oneOfType([array, object]).isRequired,
	        onMouseEnter: func,
	        onMouseLeave: func
	    },
	
	    render: function render() {
	        var _props = this.props,
	            x = _props.x,
	            y = _props.y,
	            width = _props.width,
	            height = _props.height,
	            fill = _props.fill,
	            data = _props.data,
	            onMouseEnter = _props.onMouseEnter,
	            _onMouseLeave = _props.onMouseLeave;
	
	
	        return _react2.default.createElement('rect', {
	            className: 'bar',
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            fill: fill,
	            onMouseMove: function onMouseMove(e) {
	                return onMouseEnter(e, data);
	            },
	            onMouseLeave: function onMouseLeave(e) {
	                return _onMouseLeave(e);
	            }
	        });
	    }
	});
	
	exports.default = Bar;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var string = _propTypes2.default.string,
	    array = _propTypes2.default.array;
	
	
	var Path = (0, _createReactClass2.default)({
	    displayName: 'Path',
	
	    propTypes: {
	        className: string,
	        stroke: string.isRequired,
	        strokeLinecap: string,
	        strokeWidth: string,
	        strokeDasharray: string,
	        fill: string,
	        d: string.isRequired,
	        data: array.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            className: 'path',
	            fill: 'none',
	            strokeWidth: '2',
	            strokeLinecap: 'butt',
	            strokeDasharray: 'none'
	        };
	    },
	    render: function render() {
	        var _props = this.props,
	            className = _props.className,
	            stroke = _props.stroke,
	            strokeWidth = _props.strokeWidth,
	            strokeLinecap = _props.strokeLinecap,
	            strokeDasharray = _props.strokeDasharray,
	            fill = _props.fill,
	            d = _props.d,
	            style = _props.style,
	            data = _props.data,
	            onMouseEnter = _props.onMouseEnter,
	            _onMouseLeave = _props.onMouseLeave;
	
	
	        return _react2.default.createElement('path', {
	            className: className,
	            stroke: stroke,
	            strokeWidth: strokeWidth,
	            strokeLinecap: strokeLinecap,
	            strokeDasharray: strokeDasharray,
	            fill: fill,
	            d: d,
	            onMouseMove: function onMouseMove(evt) {
	                return onMouseEnter(evt, data);
	            },
	            onMouseLeave: function onMouseLeave(evt) {
	                return _onMouseLeave(evt);
	            },
	            style: style
	        });
	    }
	});
	
	exports.default = Path;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _d = __webpack_require__(4);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Axis = __webpack_require__(11);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _Path = __webpack_require__(22);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	var _Tooltip = __webpack_require__(13);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DefaultPropsMixin = __webpack_require__(8);
	
	var _DefaultPropsMixin2 = _interopRequireDefault(_DefaultPropsMixin);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	var _ArrayifyMixin = __webpack_require__(10);
	
	var _ArrayifyMixin2 = _interopRequireDefault(_ArrayifyMixin);
	
	var _StackAccessorMixin = __webpack_require__(16);
	
	var _StackAccessorMixin2 = _interopRequireDefault(_StackAccessorMixin);
	
	var _StackDataMixin = __webpack_require__(17);
	
	var _StackDataMixin2 = _interopRequireDefault(_StackDataMixin);
	
	var _DefaultScalesMixin = __webpack_require__(12);
	
	var _DefaultScalesMixin2 = _interopRequireDefault(_DefaultScalesMixin);
	
	var _TooltipMixin = __webpack_require__(9);
	
	var _TooltipMixin2 = _interopRequireDefault(_TooltipMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var array = _propTypes2.default.array,
	    func = _propTypes2.default.func,
	    string = _propTypes2.default.string;
	
	
	var DataSet = (0, _createReactClass2.default)({
	    displayName: 'DataSet',
	
	    propTypes: {
	        data: array.isRequired,
	        area: func.isRequired,
	        line: func.isRequired,
	        colorScale: func.isRequired,
	        stroke: func.isRequired
	    },
	
	    render: function render() {
	        var _props = this.props,
	            data = _props.data,
	            area = _props.area,
	            colorScale = _props.colorScale,
	            values = _props.values,
	            label = _props.label,
	            onMouseEnter = _props.onMouseEnter,
	            onMouseLeave = _props.onMouseLeave;
	
	
	        var areas = data.map(function (stack, index) {
	            return _react2.default.createElement(_Path2.default, {
	                key: label(stack) + '.' + index,
	                className: 'area',
	                stroke: 'none',
	                fill: colorScale(label(stack)),
	                d: area(values(stack)),
	                onMouseEnter: onMouseEnter,
	                onMouseLeave: onMouseLeave,
	                data: data
	            });
	        });
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            areas
	        );
	    }
	});
	
	var AreaChart = (0, _createReactClass2.default)({
	    displayName: 'AreaChart',
	
	    mixins: [_DefaultPropsMixin2.default, _HeightWidthMixin2.default, _ArrayifyMixin2.default, _StackAccessorMixin2.default, _StackDataMixin2.default, _DefaultScalesMixin2.default, _TooltipMixin2.default],
	
	    propTypes: {
	        interpolate: string,
	        stroke: func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            interpolate: 'linear',
	            stroke: _d2.default.scale.category20()
	        };
	    },
	    _tooltipHtml: function _tooltipHtml(d, position) {
	        var _props2 = this.props,
	            x = _props2.x,
	            y0 = _props2.y0,
	            y = _props2.y,
	            values = _props2.values;
	
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	
	        var xValueCursor = xScale.invert(position[0]);
	
	        var xBisector = _d2.default.bisector(function (e) {
	            return x(e);
	        }).right;
	        var xIndex = xBisector(values(d[0]), xScale.invert(position[0]));
	        xIndex = xIndex == values(d[0]).length ? xIndex - 1 : xIndex;
	
	        var xIndexRight = xIndex == values(d[0]).length ? xIndex - 1 : xIndex;
	        var xValueRight = x(values(d[0])[xIndexRight]);
	
	        var xIndexLeft = xIndex == 0 ? xIndex : xIndex - 1;
	        var xValueLeft = x(values(d[0])[xIndexLeft]);
	
	        if (Math.abs(xValueCursor - xValueRight) < Math.abs(xValueCursor - xValueLeft)) {
	            xIndex = xIndexRight;
	        } else {
	            xIndex = xIndexLeft;
	        }
	
	        var yValueCursor = yScale.invert(position[1]);
	
	        var yBisector = _d2.default.bisector(function (e) {
	            return y0(values(e)[xIndex]) + y(values(e)[xIndex]);
	        }).left;
	        var yIndex = yBisector(d, yValueCursor);
	        yIndex = yIndex == d.length ? yIndex - 1 : yIndex;
	
	        var yValue = y(values(d[yIndex])[xIndex]);
	        var yValueCumulative = y0(values(d[d.length - 1])[xIndex]) + y(values(d[d.length - 1])[xIndex]);
	
	        var xValue = x(values(d[yIndex])[xIndex]);
	
	        var xPos = xScale(xValue);
	        var yPos = yScale(y0(values(d[yIndex])[xIndex]) + yValue);
	
	        return [this.props.tooltipHtml(yValue, yValueCumulative, xValue), xPos, yPos];
	    },
	    render: function render() {
	        var _props3 = this.props,
	            height = _props3.height,
	            width = _props3.width,
	            margin = _props3.margin,
	            viewBox = _props3.viewBox,
	            preserveAspectRatio = _props3.preserveAspectRatio,
	            colorScale = _props3.colorScale,
	            interpolate = _props3.interpolate,
	            stroke = _props3.stroke,
	            values = _props3.values,
	            label = _props3.label,
	            x = _props3.x,
	            y = _props3.y,
	            y0 = _props3.y0,
	            xAxis = _props3.xAxis,
	            yAxis = _props3.yAxis,
	            yOrientation = _props3.yOrientation;
	
	
	        var data = this._data;
	        var innerWidth = this._innerWidth;
	        var innerHeight = this._innerHeight;
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	
	        var line = _d2.default.svg.line().x(function (e) {
	            return xScale(x(e));
	        }).y(function (e) {
	            return yScale(y0(e) + y(e));
	        }).interpolate(interpolate);
	
	        var area = _d2.default.svg.area().x(function (e) {
	            return xScale(x(e));
	        }).y0(function (e) {
	            return yScale(yScale.domain()[0] + y0(e));
	        }).y1(function (e) {
	            return yScale(y0(e) + y(e));
	        }).interpolate(interpolate);
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                { height: height, width: width, margin: margin, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	                _react2.default.createElement(DataSet, {
	                    data: data,
	                    line: line,
	                    area: area,
	                    colorScale: colorScale,
	                    stroke: stroke,
	                    label: label,
	                    values: values,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave
	                }),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'x axis',
	                    orientation: 'bottom',
	                    scale: xScale,
	                    height: innerHeight,
	                    width: innerWidth
	                }, xAxis)),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'y axis',
	                    orientation: yOrientation ? yOrientation : 'left',
	                    scale: yScale,
	                    height: innerHeight,
	                    width: innerWidth
	                }, yAxis)),
	                this.props.children
	            ),
	            _react2.default.createElement(_Tooltip2.default, this.state.tooltip)
	        );
	    }
	});
	
	exports.default = AreaChart;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Axis = __webpack_require__(11);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _Bar = __webpack_require__(21);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Tooltip = __webpack_require__(13);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DefaultPropsMixin = __webpack_require__(8);
	
	var _DefaultPropsMixin2 = _interopRequireDefault(_DefaultPropsMixin);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	var _ArrayifyMixin = __webpack_require__(10);
	
	var _ArrayifyMixin2 = _interopRequireDefault(_ArrayifyMixin);
	
	var _StackAccessorMixin = __webpack_require__(16);
	
	var _StackAccessorMixin2 = _interopRequireDefault(_StackAccessorMixin);
	
	var _StackDataMixin = __webpack_require__(17);
	
	var _StackDataMixin2 = _interopRequireDefault(_StackDataMixin);
	
	var _DefaultScalesMixin = __webpack_require__(12);
	
	var _DefaultScalesMixin2 = _interopRequireDefault(_DefaultScalesMixin);
	
	var _TooltipMixin = __webpack_require__(9);
	
	var _TooltipMixin2 = _interopRequireDefault(_TooltipMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var array = _propTypes2.default.array,
	    func = _propTypes2.default.func;
	
	
	var DataSet = (0, _createReactClass2.default)({
	    displayName: 'DataSet',
	
	    propTypes: {
	        data: array.isRequired,
	        xScale: func.isRequired,
	        yScale: func.isRequired,
	        colorScale: func.isRequired,
	        values: func.isRequired,
	        label: func.isRequired,
	        x: func.isRequired,
	        y: func.isRequired,
	        y0: func.isRequired
	    },
	
	    render: function render() {
	        var _props = this.props,
	            data = _props.data,
	            xScale = _props.xScale,
	            yScale = _props.yScale,
	            colorScale = _props.colorScale,
	            values = _props.values,
	            label = _props.label,
	            x = _props.x,
	            y = _props.y,
	            y0 = _props.y0,
	            onMouseEnter = _props.onMouseEnter,
	            onMouseLeave = _props.onMouseLeave,
	            groupedBars = _props.groupedBars,
	            colorByLabel = _props.colorByLabel;
	
	
	        var bars = void 0;
	        if (groupedBars) {
	            bars = data.map(function (stack, serieIndex) {
	                return values(stack).map(function (e, index) {
	                    var yVal = y(e) < 0 ? yScale(0) : yScale(y(e));
	                    return _react2.default.createElement(_Bar2.default, {
	                        key: label(stack) + '.' + index,
	                        width: xScale.rangeBand() / data.length,
	                        height: Math.abs(yScale(0) - yScale(y(e))),
	                        x: xScale(x(e)) + xScale.rangeBand() * serieIndex / data.length,
	                        y: yVal,
	                        fill: colorScale(label(stack)),
	                        data: e,
	                        onMouseEnter: onMouseEnter,
	                        onMouseLeave: onMouseLeave
	                    });
	                });
	            });
	        } else {
	            bars = data.map(function (stack) {
	                return values(stack).map(function (e, index) {
	                    var color = colorByLabel ? colorScale(label(stack)) : colorScale(x(e));
	                    var yVal = y(e) < 0 ? yScale(y0(e)) : yScale(y0(e) + y(e));
	                    return _react2.default.createElement(_Bar2.default, {
	                        key: label(stack) + '.' + index,
	                        width: xScale.rangeBand(),
	                        height: Math.abs(yScale(y0(e) + y(e)) - yScale(y0(e))),
	                        x: xScale(x(e)),
	                        y: yVal,
	                        fill: color,
	                        data: e,
	                        onMouseEnter: onMouseEnter,
	                        onMouseLeave: onMouseLeave
	                    });
	                });
	            });
	        }
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            bars
	        );
	    }
	});
	
	var BarChart = (0, _createReactClass2.default)({
	    displayName: 'BarChart',
	
	    mixins: [_DefaultPropsMixin2.default, _HeightWidthMixin2.default, _ArrayifyMixin2.default, _StackAccessorMixin2.default, _StackDataMixin2.default, _DefaultScalesMixin2.default, _TooltipMixin2.default],
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            colorByLabel: true
	        };
	    },
	    _tooltipHtml: function _tooltipHtml(d) {
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	
	        var html = this.props.tooltipHtml(this.props.x(d), this.props.y0(d), this.props.y(d));
	
	        var midPoint = xScale.rangeBand() / 2;
	        var xPos = midPoint + xScale(this.props.x(d));
	
	        var topStack = this._data[this._data.length - 1].values;
	        var topElement = null;
	
	        // TODO: this might not scale if dataset is huge.
	        // consider pre-computing yPos for each X
	        for (var i = 0; i < topStack.length; i++) {
	            if (this.props.x(topStack[i]) === this.props.x(d)) {
	                topElement = topStack[i];
	                break;
	            }
	        }
	        var yPos = yScale(this.props.y0(topElement) + this.props.y(topElement));
	
	        return [html, xPos, yPos];
	    },
	    render: function render() {
	        var _props2 = this.props,
	            xAxis = _props2.xAxis,
	            yAxis = _props2.yAxis,
	            height = _props2.height,
	            width = _props2.width,
	            margin = _props2.margin,
	            viewBox = _props2.viewBox,
	            preserveAspectRatio = _props2.preserveAspectRatio,
	            colorScale = _props2.colorScale,
	            values = _props2.values,
	            label = _props2.label,
	            y = _props2.y,
	            y0 = _props2.y0,
	            x = _props2.x,
	            groupedBars = _props2.groupedBars,
	            colorByLabel = _props2.colorByLabel,
	            tickFormat = _props2.tickFormat;
	
	
	        var data = this._data;
	        var innerWidth = this._innerWidth;
	        var innerHeight = this._innerHeight;
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	        var yIntercept = this._yIntercept;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                { height: height, width: width, margin: margin, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	                _react2.default.createElement(DataSet, {
	                    data: data,
	                    xScale: xScale,
	                    yScale: yScale,
	                    colorScale: colorScale,
	                    values: values,
	                    label: label,
	                    y: y,
	                    y0: y0,
	                    x: x,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave,
	                    groupedBars: groupedBars,
	                    colorByLabel: colorByLabel
	                }),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'x axis',
	                    orientation: 'bottom',
	                    scale: xScale,
	                    height: innerHeight,
	                    width: innerWidth,
	                    zero: yIntercept,
	                    tickFormat: tickFormat
	                }, xAxis)),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'y axis',
	                    orientation: 'left',
	                    scale: yScale,
	                    height: innerHeight,
	                    width: innerWidth,
	                    tickFormat: tickFormat
	                }, yAxis)),
	                this.props.children
	            ),
	            _react2.default.createElement(_Tooltip2.default, this.state.tooltip)
	        );
	    }
	});
	
	exports.default = BarChart;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Axis = __webpack_require__(11);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Adapted for React from https://github.com/mbostock/d3/blob/master/src/svg/brush.js
	// TODO: Add D3 License
	var _d3SvgBrushCursor = {
	    n: 'ns-resize',
	    e: 'ew-resize',
	    s: 'ns-resize',
	    w: 'ew-resize',
	    nw: 'nwse-resize',
	    ne: 'nesw-resize',
	    se: 'nwse-resize',
	    sw: 'nesw-resize'
	};
	
	var _d3SvgBrushResizes = [['n', 'e', 's', 'w', 'nw', 'ne', 'se', 'sw'], ['e', 'w'], ['n', 's'], []];
	
	// TODO: add y axis support
	var Brush = (0, _createReactClass2.default)({
	    displayName: 'Brush',
	
	    mixins: [_HeightWidthMixin2.default],
	
	    getInitialState: function getInitialState() {
	        return {
	            resizers: _d3SvgBrushResizes[0],
	            xExtent: [0, 0],
	            yExtent: [0, 0],
	            xExtentDomain: undefined,
	            yExtentDomain: undefined
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            xScale: null,
	            yScale: null
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        this._extent(this.props.extent);
	
	        this.setState({
	            resizers: _d3SvgBrushResizes[!this.props.xScale << 1 | !this.props.yScale]
	        });
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        // when <Brush/> is used inside a component
	        // we should not set the extent prop on every redraw of the parent, because it will
	        // stop us from actually setting the extent with the brush.
	        if (nextProps.xScale !== this.props.xScale) {
	            this._extent(nextProps.extent, nextProps.xScale);
	            this.setState({
	                resizers: _d3SvgBrushResizes[!this.props.xScale << 1 | !this.props.yScale]
	            });
	        }
	    },
	    render: function render() {
	        var _this = this;
	
	        // TODO: remove this.state this.props
	        var xRange = this.props.xScale ? this._d3ScaleRange(this.props.xScale) : null;
	        var yRange = this.props.yScale ? this._d3ScaleRange(this.props.yScale) : null;
	
	        var background = _react2.default.createElement('rect', {
	            className: 'background',
	            style: { visibility: 'visible', cursor: 'crosshair' },
	            x: xRange ? xRange[0] : '',
	            width: xRange ? xRange[1] - xRange[0] : '',
	            y: yRange ? yRange[0] : '',
	            height: yRange ? yRange[1] - yRange[0] : this._innerHeight,
	            onMouseDown: this._onMouseDownBackground
	        });
	
	        // TODO: it seems like actually we can have both x and y scales at the same time. need to find example.
	
	        var extent = void 0;
	        if (this.props.xScale) {
	            extent = _react2.default.createElement('rect', {
	                className: 'extent',
	                style: { cursor: 'move' },
	                x: this.state.xExtent[0],
	                width: this.state.xExtent[1] - this.state.xExtent[0],
	                height: this._innerHeight,
	                onMouseDown: this._onMouseDownExtent
	            });
	        }
	
	        var resizers = this.state.resizers.map(function (e) {
	            return _react2.default.createElement(
	                'g',
	                {
	                    key: e,
	                    className: 'resize ' + e,
	                    style: { cursor: _d3SvgBrushCursor[e] },
	                    transform: 'translate(' + _this.state.xExtent[+/e$/.test(e)] + ', ' + _this.state.yExtent[+/^s/.test(e)] + ')',
	                    onMouseDown: function onMouseDown(event) {
	                        _this._onMouseDownResizer(event, e);
	                    }
	                },
	                _react2.default.createElement('rect', {
	                    x: /[ew]$/.test(e) ? -3 : null,
	                    y: /^[ns]/.test(e) ? -3 : null,
	                    width: '6',
	                    height: _this._innerHeight,
	                    style: { visibility: 'hidden', display: _this._empty() ? 'none' : null }
	                })
	            );
	        });
	
	        var _props = this.props,
	            height = _props.height,
	            width = _props.width,
	            margin = _props.margin,
	            viewBox = _props.viewBox,
	            preserveAspectRatio = _props.preserveAspectRatio;
	
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                { height: height, width: width, margin: margin, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	                _react2.default.createElement(
	                    'g',
	                    {
	                        style: { pointerEvents: 'all' },
	                        onMouseUp: this._onMouseUp,
	                        onMouseMove: this._onMouseMove
	                    },
	                    background,
	                    extent,
	                    resizers
	                ),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'x axis',
	                    orientation: 'bottom',
	                    scale: this.props.xScale,
	                    height: this._innerHeight,
	                    width: this._innerWidth
	                }, this.props.xAxis)),
	                this.props.children
	            )
	        );
	    },
	
	
	    // TODO: Code duplicated in TooltipMixin.jsx, move outside.
	    _getMousePosition: function _getMousePosition(e) {
	        var svg = _reactDom2.default.findDOMNode(this).getElementsByTagName('svg')[0];
	        var position = void 0;
	        if (svg.createSVGPoint) {
	            var point = svg.createSVGPoint();
	            point.x = e.clientX;
	            point.y = e.clientY;
	            point = point.matrixTransform(svg.getScreenCTM().inverse());
	            position = [point.x - this.props.margin.left, point.y - this.props.margin.top];
	        } else {
	            var rect = svg.getBoundingClientRect();
	            position = [e.clientX - rect.left - svg.clientLeft - this.props.margin.left, e.clientY - rect.top - svg.clientTop - this.props.margin.left];
	        }
	
	        return position;
	    },
	    _onMouseDownBackground: function _onMouseDownBackground(e) {
	        e.preventDefault();
	        var range = this._d3ScaleRange(this.props.xScale);
	        var point = this._getMousePosition(e);
	
	        var size = this.state.xExtent[1] - this.state.xExtent[0];
	
	        range[1] -= size;
	
	        var min = Math.max(range[0], Math.min(range[1], point[0]));
	        this.setState({ xExtent: [min, min + size] });
	    },
	
	
	    // TODO: use constants instead of strings
	    _onMouseDownExtent: function _onMouseDownExtent(e) {
	        e.preventDefault();
	        this._mouseMode = 'drag';
	
	        var point = this._getMousePosition(e);
	        var distanceFromBorder = point[0] - this.state.xExtent[0];
	
	        this._startPosition = distanceFromBorder;
	    },
	    _onMouseDownResizer: function _onMouseDownResizer(e, dir) {
	        e.preventDefault();
	        this._mouseMode = 'resize';
	        this._resizeDir = dir;
	    },
	    _onDrag: function _onDrag(e) {
	        var range = this._d3ScaleRange(this.props.xScale);
	        var point = this._getMousePosition(e);
	
	        var size = this.state.xExtent[1] - this.state.xExtent[0];
	
	        range[1] -= size;
	
	        var min = Math.max(range[0], Math.min(range[1], point[0] - this._startPosition));
	
	        this.setState({ xExtent: [min, min + size], xExtentDomain: null });
	    },
	    _onResize: function _onResize(e) {
	        var range = this._d3ScaleRange(this.props.xScale);
	        var point = this._getMousePosition(e);
	        // Don't let the extent go outside of its limits
	        // TODO: support clamp argument of D3
	        var min = Math.max(range[0], Math.min(range[1], point[0]));
	
	        if (this._resizeDir == 'w') {
	            if (min > this.state.xExtent[1]) {
	                this.setState({ xExtent: [this.state.xExtent[1], min], xExtentDomain: null });
	                this._resizeDir = 'e';
	            } else {
	                this.setState({ xExtent: [min, this.state.xExtent[1]], xExtentDomain: null });
	            }
	        } else if (this._resizeDir == 'e') {
	            if (min < this.state.xExtent[0]) {
	                this.setState({ xExtent: [min, this.state.xExtent[0]], xExtentDomain: null });
	                this._resizeDir = 'w';
	            } else {
	                this.setState({ xExtent: [this.state.xExtent[0], min], xExtentDomain: null });
	            }
	        }
	    },
	    _onMouseMove: function _onMouseMove(e) {
	        e.preventDefault();
	
	        if (this._mouseMode == 'resize') {
	            this._onResize(e);
	        } else if (this._mouseMode == 'drag') {
	            this._onDrag(e);
	        }
	    },
	    _onMouseUp: function _onMouseUp(e) {
	        e.preventDefault();
	
	        this._mouseMode = null;
	
	        this.props.onChange(this._extent());
	    },
	    _extent: function _extent(z, xScale) {
	        var x = xScale || this.props.xScale;
	        var y = this.props.yScale;
	
	        var _state = this.state,
	            xExtent = _state.xExtent,
	            yExtent = _state.yExtent,
	            xExtentDomain = _state.xExtentDomain,
	            yExtentDomain = _state.yExtentDomain;
	
	
	        var x0 = void 0,
	            x1 = void 0,
	            y0 = void 0,
	            y1 = void 0,
	            t = void 0;
	
	        // Invert the pixel extent to data-space.
	        if (!arguments.length) {
	            if (x) {
	                if (xExtentDomain) {
	                    x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	                } else {
	                    x0 = xExtent[0], x1 = xExtent[1];
	                    if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	                    if (x1 < x0) t = x0, x0 = x1, x1 = t;
	                }
	            }
	            if (y) {
	                if (yExtentDomain) {
	                    y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	                } else {
	                    y0 = yExtent[0], y1 = yExtent[1];
	                    if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	                    if (y1 < y0) t = y0, y0 = y1, y1 = t;
	                }
	            }
	            return x && y ? [[x0, y0], [x1, y1]] : x ? [x0, x1] : y && [y0, y1];
	        }
	
	        // Scale the data-space extent to pixels.
	        if (x) {
	            x0 = z[0], x1 = z[1];
	            if (y) x0 = x0[0], x1 = x1[0];
	            xExtentDomain = [x0, x1];
	            if (x.invert) x0 = x(x0), x1 = x(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	            if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [x0, x1]; // copy-on-write
	        }
	        if (y) {
	            y0 = z[0], y1 = z[1];
	            if (x) y0 = y0[1], y1 = y1[1];
	            yExtentDomain = [y0, y1];
	            if (y.invert) y0 = y(y0), y1 = y(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	            if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [y0, y1]; // copy-on-write
	        }
	
	        this.setState({ xExtent: xExtent, yExtent: yExtent, xExtentDomain: xExtentDomain, yExtentDomain: yExtentDomain });
	    },
	    _empty: function _empty() {
	        return !!this.props.xScale && this.state.xExtent[0] == this.state.xExtent[1] || !!this.props.yScale && this.state.yExtent[0] == this.state.yExtent[1];
	    },
	
	
	    // TODO: Code duplicated in Axis.jsx, move outside.
	    _d3ScaleExtent: function _d3ScaleExtent(domain) {
	        var start = domain[0];
	        var stop = domain[domain.length - 1];
	        return start < stop ? [start, stop] : [stop, start];
	    },
	    _d3ScaleRange: function _d3ScaleRange(scale) {
	        return scale.rangeExtent ? scale.rangeExtent() : this._d3ScaleExtent(scale.range());
	    }
	});
	
	exports.default = Brush;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _d = __webpack_require__(4);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Axis = __webpack_require__(11);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _Path = __webpack_require__(22);
	
	var _Path2 = _interopRequireDefault(_Path);
	
	var _Tooltip = __webpack_require__(13);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DefaultPropsMixin = __webpack_require__(8);
	
	var _DefaultPropsMixin2 = _interopRequireDefault(_DefaultPropsMixin);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	var _ArrayifyMixin = __webpack_require__(10);
	
	var _ArrayifyMixin2 = _interopRequireDefault(_ArrayifyMixin);
	
	var _AccessorMixin = __webpack_require__(15);
	
	var _AccessorMixin2 = _interopRequireDefault(_AccessorMixin);
	
	var _DefaultScalesMixin = __webpack_require__(12);
	
	var _DefaultScalesMixin2 = _interopRequireDefault(_DefaultScalesMixin);
	
	var _TooltipMixin = __webpack_require__(9);
	
	var _TooltipMixin2 = _interopRequireDefault(_TooltipMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var array = _propTypes2.default.array,
	    func = _propTypes2.default.func,
	    string = _propTypes2.default.string;
	
	
	var DataSet = (0, _createReactClass2.default)({
	    displayName: 'DataSet',
	
	    propTypes: {
	        data: array.isRequired,
	        line: func.isRequired,
	        colorScale: func.isRequired
	    },
	
	    render: function render() {
	        var _props = this.props,
	            width = _props.width,
	            height = _props.height,
	            data = _props.data,
	            line = _props.line,
	            strokeWidth = _props.strokeWidth,
	            strokeLinecap = _props.strokeLinecap,
	            strokeDasharray = _props.strokeDasharray,
	            colorScale = _props.colorScale,
	            values = _props.values,
	            label = _props.label,
	            onMouseEnter = _props.onMouseEnter,
	            _onMouseLeave = _props.onMouseLeave;
	
	
	        var sizeId = width + 'x' + height;
	
	        var lines = data.map(function (stack, index) {
	            return _react2.default.createElement(_Path2.default, {
	                key: label(stack) + '.' + index,
	                className: 'line',
	                d: line(values(stack)),
	                stroke: colorScale(label(stack)),
	                strokeWidth: typeof strokeWidth === 'function' ? strokeWidth(label(stack)) : strokeWidth,
	                strokeLinecap: typeof strokeLinecap === 'function' ? strokeLinecap(label(stack)) : strokeLinecap,
	                strokeDasharray: typeof strokeDasharray === 'function' ? strokeDasharray(label(stack)) : strokeDasharray,
	                data: values(stack),
	                onMouseEnter: onMouseEnter,
	                onMouseLeave: _onMouseLeave,
	                style: { clipPath: 'url(#lineClip_' + sizeId + ')' }
	            });
	        });
	
	        /*
	         The <rect> below is needed in case we want to show the tooltip no matter where on the chart the mouse is.
	         Not sure if this should be used.
	         */
	        return _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement(
	                'defs',
	                null,
	                _react2.default.createElement(
	                    'clipPath',
	                    { id: 'lineClip_' + sizeId },
	                    _react2.default.createElement('rect', { width: width, height: height })
	                )
	            ),
	            lines,
	            _react2.default.createElement('rect', {
	                width: width,
	                height: height,
	                fill: 'none',
	                stroke: 'none',
	                style: { pointerEvents: 'all' },
	                onMouseMove: function onMouseMove(evt) {
	                    onMouseEnter(evt, data);
	                },
	                onMouseLeave: function onMouseLeave(evt) {
	                    _onMouseLeave(evt);
	                }
	            })
	        );
	    }
	});
	
	var LineChart = (0, _createReactClass2.default)({
	    displayName: 'LineChart',
	
	    mixins: [_DefaultPropsMixin2.default, _HeightWidthMixin2.default, _ArrayifyMixin2.default, _AccessorMixin2.default, _DefaultScalesMixin2.default, _TooltipMixin2.default],
	
	    propTypes: {
	        interpolate: string,
	        defined: func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            interpolate: 'linear',
	            defined: function defined() {
	                return true;
	            },
	            shape: 'circle',
	            shapeColor: null,
	            showCustomLine: false,
	            lineStructureClassName: "dot",
	            customPointColor: "blue",
	            customPointShape: "circle"
	        };
	    },
	
	
	    /*
	     The code below supports finding the data values for the line closest to the mouse cursor.
	     Since it gets all events from the Rect overlaying the Chart the tooltip gets shown everywhere.
	     For now I don't want to use this method.
	     */
	    _tooltipHtml: function _tooltipHtml(data, position) {
	        var _props2 = this.props,
	            x = _props2.x,
	            y = _props2.y,
	            values = _props2.values,
	            label = _props2.label;
	
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	
	        var xValueCursor = xScale.invert(position[0]);
	        var yValueCursor = yScale.invert(position[1]);
	
	        var xBisector = _d2.default.bisector(function (e) {
	            return x(e);
	        }).left;
	        var valuesAtX = data.map(function (stack) {
	            var idx = xBisector(values(stack), xValueCursor);
	
	            var indexRight = idx === values(stack).length ? idx - 1 : idx;
	            var valueRight = x(values(stack)[indexRight]);
	
	            var indexLeft = idx === 0 ? idx : idx - 1;
	            var valueLeft = x(values(stack)[indexLeft]);
	
	            var index = void 0;
	            if (Math.abs(xValueCursor - valueRight) < Math.abs(xValueCursor - valueLeft)) {
	                index = indexRight;
	            } else {
	                index = indexLeft;
	            }
	
	            return { label: label(stack), value: values(stack)[index] };
	        });
	
	        valuesAtX.sort(function (a, b) {
	            return y(a.value) - y(b.value);
	        });
	
	        var yBisector = _d2.default.bisector(function (e) {
	            return y(e.value);
	        }).left;
	        var yIndex = yBisector(valuesAtX, yValueCursor);
	
	        var yIndexRight = yIndex === valuesAtX.length ? yIndex - 1 : yIndex;
	        var yIndexLeft = yIndex === 0 ? yIndex : yIndex - 1;
	
	        var yValueRight = y(valuesAtX[yIndexRight].value);
	        var yValueLeft = y(valuesAtX[yIndexLeft].value);
	
	        var index = void 0;
	        if (Math.abs(yValueCursor - yValueRight) < Math.abs(yValueCursor - yValueLeft)) {
	            index = yIndexRight;
	        } else {
	            index = yIndexLeft;
	        }
	
	        this._tooltipData = valuesAtX[index];
	
	        var html = this.props.tooltipHtml(valuesAtX[index].label, valuesAtX[index].value);
	
	        var xPos = xScale(valuesAtX[index].value.x);
	        var yPos = yScale(valuesAtX[index].value.y);
	
	        return [html, xPos, yPos];
	    },
	
	
	    /*
	    _tooltipHtml(data, position) {
	        let {x, y0, y, values, label} = this.props;
	        let [xScale, yScale] = [this._xScale, this._yScale];
	         let xValueCursor = xScale.invert(position[0]);
	        let yValueCursor = yScale.invert(position[1]);
	         let xBisector = d3.bisector(e => { return x(e); }).left;
	        let xIndex = xBisector(data, xScale.invert(position[0]));
	         let indexRight = xIndex == data.length ? xIndex - 1 : xIndex;
	        let valueRight = x(data[indexRight]);
	         let indexLeft = xIndex == 0 ? xIndex : xIndex - 1;
	        let valueLeft = x(data[indexLeft]);
	         let index;
	        if (Math.abs(xValueCursor - valueRight) < Math.abs(xValueCursor - valueLeft)) {
	            index = indexRight;
	        } else {
	            index = indexLeft;
	        }
	         let yValue = y(data[index]);
	        let cursorValue = d3.round(yScale.invert(position[1]), 2);
	         return this.props.tooltipHtml(yValue, cursorValue);
	    },
	     */
	
	    /*
	             stroke,
	             strokeWidth,
	             strokeLinecap,
	             strokeDasharray,
	     */
	    render: function render() {
	        var _this = this;
	
	        var _props3 = this.props,
	            height = _props3.height,
	            width = _props3.width,
	            margin = _props3.margin,
	            viewBox = _props3.viewBox,
	            preserveAspectRatio = _props3.preserveAspectRatio,
	            colorScale = _props3.colorScale,
	            interpolate = _props3.interpolate,
	            defined = _props3.defined,
	            stroke = _props3.stroke,
	            values = _props3.values,
	            label = _props3.label,
	            x = _props3.x,
	            y = _props3.y,
	            xAxis = _props3.xAxis,
	            yAxis = _props3.yAxis,
	            shape = _props3.shape,
	            shapeColor = _props3.shapeColor,
	            showCustomLine = _props3.showCustomLine,
	            lineStructureClassName = _props3.lineStructureClassName,
	            customPointColor = _props3.customPointColor,
	            customPointShape = _props3.customPointShape;
	
	
	        var data = this._data;
	        var innerWidth = this._innerWidth;
	        var innerHeight = this._innerHeight;
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	        var xIntercept = this._xIntercept;
	        var yIntercept = this._yIntercept;
	
	        var line = _d2.default.svg.line().x(function (e) {
	            return xScale(x(e));
	        }).y(function (e) {
	            return yScale(y(e));
	        }).interpolate(interpolate).defined(defined);
	
	        var tooltipSymbol = null,
	            points = null;
	        if (!this.state.tooltip.hidden) {
	            var symbol = _d2.default.svg.symbol().type(shape);
	            var symbolColor = shapeColor ? shapeColor : colorScale(this._tooltipData.label);
	
	            var translate = this._tooltipData ? 'translate(' + xScale(x(this._tooltipData.value)) + ', ' + yScale(y(this._tooltipData.value)) + ')' : '';
	            tooltipSymbol = this.state.tooltip.hidden ? null : _react2.default.createElement('path', {
	                className: 'dot',
	                d: symbol(),
	                transform: translate,
	                fill: symbolColor,
	                onMouseEnter: function onMouseEnter(evt) {
	                    return _this.onMouseEnter(evt, data);
	                },
	                onMouseLeave: function onMouseLeave(evt) {
	                    return _this.onMouseLeave(evt);
	                }
	            });
	        }
	
	        if (showCustomLine) {
	            var translatePoints = function translatePoints(point) {
	                return 'translate(' + xScale(x(point)) + ', ' + yScale(y(point)) + ')';
	            };
	
	            points = data.map(function (d, dataIndex) {
	                return d.values.map(function (p, i) {
	                    return _react2.default.createElement('path', {
	                        key: i,
	                        className: lineStructureClassName,
	                        d: _d2.default.svg.symbol().type(customPointShape)(),
	                        transform: translatePoints(p),
	                        fill: customPointColor,
	                        onMouseEnter: function onMouseEnter(evt) {
	                            return _this.onMouseEnter(evt, data);
	                        },
	                        onMouseLeave: function onMouseLeave(evt) {
	                            return _this.onMouseLeave(evt);
	                        }
	                    });
	                });
	            });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                { height: height, width: width, margin: margin, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'x axis',
	                    orientation: 'bottom',
	                    scale: xScale,
	                    height: innerHeight,
	                    width: innerWidth,
	                    zero: yIntercept
	                }, xAxis)),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'y axis',
	                    orientation: 'left',
	                    scale: yScale,
	                    height: innerHeight,
	                    width: innerWidth,
	                    zero: xIntercept
	                }, yAxis)),
	                _react2.default.createElement(DataSet, _extends({
	                    height: innerHeight,
	                    width: innerWidth,
	                    data: data,
	                    line: line,
	                    colorScale: colorScale,
	                    values: values,
	                    label: label,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave
	                }, stroke)),
	                this.props.children,
	                tooltipSymbol,
	                points
	            ),
	            _react2.default.createElement(_Tooltip2.default, this.state.tooltip)
	        );
	    }
	});
	
	exports.default = LineChart;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _d = __webpack_require__(4);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Tooltip = __webpack_require__(13);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DefaultPropsMixin = __webpack_require__(8);
	
	var _DefaultPropsMixin2 = _interopRequireDefault(_DefaultPropsMixin);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	var _AccessorMixin = __webpack_require__(15);
	
	var _AccessorMixin2 = _interopRequireDefault(_AccessorMixin);
	
	var _TooltipMixin = __webpack_require__(9);
	
	var _TooltipMixin2 = _interopRequireDefault(_TooltipMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var string = _propTypes2.default.string,
	    array = _propTypes2.default.array,
	    number = _propTypes2.default.number,
	    bool = _propTypes2.default.bool,
	    func = _propTypes2.default.func,
	    any = _propTypes2.default.any;
	
	
	var Wedge = (0, _createReactClass2.default)({
	    displayName: 'Wedge',
	
	    propTypes: {
	        d: string.isRequired,
	        fill: string.isRequired
	    },
	
	    render: function render() {
	        var _props = this.props,
	            fill = _props.fill,
	            d = _props.d,
	            data = _props.data,
	            onMouseEnter = _props.onMouseEnter,
	            _onMouseLeave = _props.onMouseLeave;
	
	
	        return _react2.default.createElement('path', {
	            fill: fill,
	            d: d,
	            onMouseMove: function onMouseMove(evt) {
	                return onMouseEnter(evt, data);
	            },
	            onMouseLeave: function onMouseLeave(evt) {
	                return _onMouseLeave(evt);
	            }
	        });
	    }
	});
	
	var DataSet = (0, _createReactClass2.default)({
	    displayName: 'DataSet',
	
	    propTypes: {
	        pie: array.isRequired,
	        arc: func.isRequired,
	        outerArc: func.isRequired,
	        colorScale: func.isRequired,
	        radius: number.isRequired,
	        strokeWidth: number,
	        stroke: string,
	        fill: string,
	        opacity: number,
	        x: func.isRequired,
	        hideLabels: bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            strokeWidth: 2,
	            stroke: '#000',
	            fill: 'none',
	            opacity: 0.3,
	            hideLabels: false
	        };
	    },
	    renderLabel: function renderLabel(wedge) {
	        var _props2 = this.props,
	            arc = _props2.arc,
	            outerArc = _props2.outerArc,
	            radius = _props2.radius,
	            strokeWidth = _props2.strokeWidth,
	            stroke = _props2.stroke,
	            fill = _props2.fill,
	            opacity = _props2.opacity,
	            x = _props2.x;
	
	
	        var labelPos = outerArc.centroid(wedge);
	        labelPos[0] = radius * (this.midAngle(wedge) < Math.PI ? 1 : -1);
	
	        var linePos = outerArc.centroid(wedge);
	        linePos[0] = radius * 0.95 * (this.midAngle(wedge) < Math.PI ? 1 : -1);
	
	        var textAnchor = this.midAngle(wedge) < Math.PI ? 'start' : 'end';
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('polyline', {
	                opacity: opacity,
	                strokeWidth: strokeWidth,
	                stroke: stroke,
	                fill: fill,
	                points: [arc.centroid(wedge), outerArc.centroid(wedge), linePos]
	            }),
	            _react2.default.createElement(
	                'text',
	                {
	                    dy: '.35em',
	                    x: labelPos[0],
	                    y: labelPos[1],
	                    textAnchor: textAnchor },
	                x(wedge.data)
	            )
	        );
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props3 = this.props,
	            pie = _props3.pie,
	            arc = _props3.arc,
	            colorScale = _props3.colorScale,
	            x = _props3.x,
	            y = _props3.y,
	            onMouseEnter = _props3.onMouseEnter,
	            onMouseLeave = _props3.onMouseLeave,
	            hideLabels = _props3.hideLabels;
	
	
	        var wedges = pie.map(function (e, index) {
	            var labelFits = e.endAngle - e.startAngle >= 10 * Math.PI / 180;
	
	            return _react2.default.createElement(
	                'g',
	                { key: x(e.data) + '.' + y(e.data) + '.' + index, className: 'arc' },
	                _react2.default.createElement(Wedge, {
	                    data: e.data,
	                    fill: colorScale(x(e.data)),
	                    d: arc(e),
	                    onMouseEnter: onMouseEnter,
	                    onMouseLeave: onMouseLeave
	                }),
	                !hideLabels && !!e.value && labelFits && _this.renderLabel(e)
	            );
	        });
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            wedges
	        );
	    },
	    midAngle: function midAngle(d) {
	        return d.startAngle + (d.endAngle - d.startAngle) / 2;
	    }
	});
	
	var PieChart = (0, _createReactClass2.default)({
	    displayName: 'PieChart',
	
	    mixins: [_DefaultPropsMixin2.default, _HeightWidthMixin2.default, _AccessorMixin2.default, _TooltipMixin2.default],
	
	    propTypes: {
	        innerRadius: number,
	        outerRadius: number,
	        labelRadius: number,
	        padRadius: string,
	        cornerRadius: number,
	        sort: any,
	        hideLabels: bool
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            innerRadius: null,
	            outerRadius: null,
	            labelRadius: null,
	            padRadius: 'auto',
	            cornerRadius: 0,
	            sort: undefined,
	            hideLabels: false
	        };
	    },
	    _tooltipHtml: function _tooltipHtml(d) {
	        var html = this.props.tooltipHtml(this.props.x(d), this.props.y(d));
	
	        return [html, 0, 0];
	    },
	    render: function render() {
	        var _props4 = this.props,
	            data = _props4.data,
	            width = _props4.width,
	            height = _props4.height,
	            margin = _props4.margin,
	            viewBox = _props4.viewBox,
	            preserveAspectRatio = _props4.preserveAspectRatio,
	            colorScale = _props4.colorScale,
	            padRadius = _props4.padRadius,
	            cornerRadius = _props4.cornerRadius,
	            sort = _props4.sort,
	            x = _props4.x,
	            y = _props4.y,
	            values = _props4.values,
	            hideLabels = _props4.hideLabels;
	        var _props5 = this.props,
	            innerRadius = _props5.innerRadius,
	            outerRadius = _props5.outerRadius,
	            labelRadius = _props5.labelRadius;
	
	
	        var innerWidth = this._innerWidth;
	        var innerHeight = this._innerHeight;
	
	        var pie = _d2.default.layout.pie().value(function (e) {
	            return y(e);
	        });
	
	        if (typeof sort !== 'undefined') {
	            pie = pie.sort(sort);
	        }
	
	        var radius = Math.min(innerWidth, innerHeight) / 2;
	        if (!innerRadius) {
	            innerRadius = radius * 0.8;
	        }
	
	        if (!outerRadius) {
	            outerRadius = radius * 0.4;
	        }
	
	        if (!labelRadius) {
	            labelRadius = radius * 0.9;
	        }
	
	        var arc = _d2.default.svg.arc().innerRadius(innerRadius).outerRadius(outerRadius).padRadius(padRadius).cornerRadius(cornerRadius);
	
	        var outerArc = _d2.default.svg.arc().innerRadius(labelRadius).outerRadius(labelRadius);
	
	        var pieData = pie(values(data));
	
	        var translation = 'translate(' + innerWidth / 2 + ', ' + innerHeight / 2 + ')';
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                { height: height, width: width, margin: margin, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	                _react2.default.createElement(
	                    'g',
	                    { transform: translation },
	                    _react2.default.createElement(DataSet, {
	                        width: innerWidth,
	                        height: innerHeight,
	                        colorScale: colorScale,
	                        pie: pieData,
	                        arc: arc,
	                        outerArc: outerArc,
	                        radius: radius,
	                        x: x,
	                        y: y,
	                        onMouseEnter: this.onMouseEnter,
	                        onMouseLeave: this.onMouseLeave,
	                        hideLabels: hideLabels
	                    })
	                ),
	                this.props.children
	            ),
	            _react2.default.createElement(_Tooltip2.default, this.state.tooltip)
	        );
	    }
	});
	
	exports.default = PieChart;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _d = __webpack_require__(4);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Axis = __webpack_require__(11);
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _Tooltip = __webpack_require__(13);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DefaultPropsMixin = __webpack_require__(8);
	
	var _DefaultPropsMixin2 = _interopRequireDefault(_DefaultPropsMixin);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	var _ArrayifyMixin = __webpack_require__(10);
	
	var _ArrayifyMixin2 = _interopRequireDefault(_ArrayifyMixin);
	
	var _AccessorMixin = __webpack_require__(15);
	
	var _AccessorMixin2 = _interopRequireDefault(_AccessorMixin);
	
	var _DefaultScalesMixin = __webpack_require__(12);
	
	var _DefaultScalesMixin2 = _interopRequireDefault(_DefaultScalesMixin);
	
	var _TooltipMixin = __webpack_require__(9);
	
	var _TooltipMixin2 = _interopRequireDefault(_TooltipMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var array = _propTypes2.default.array,
	    func = _propTypes2.default.func,
	    string = _propTypes2.default.string;
	
	
	var DataSet = (0, _createReactClass2.default)({
	    displayName: 'DataSet',
	
	    propTypes: {
	        data: array.isRequired,
	        symbol: func.isRequired,
	        xScale: func.isRequired,
	        yScale: func.isRequired,
	        colorScale: func.isRequired,
	        onMouseEnter: func,
	        onMouseLeave: func
	    },
	
	    render: function render() {
	        var _props = this.props,
	            data = _props.data,
	            symbol = _props.symbol,
	            xScale = _props.xScale,
	            yScale = _props.yScale,
	            colorScale = _props.colorScale,
	            label = _props.label,
	            values = _props.values,
	            x = _props.x,
	            y = _props.y,
	            onMouseEnter = _props.onMouseEnter,
	            _onMouseLeave = _props.onMouseLeave;
	
	
	        var circles = data.map(function (stack) {
	            return values(stack).map(function (e, index) {
	                var translate = 'translate(' + xScale(x(e)) + ', ' + yScale(y(e)) + ')';
	                return _react2.default.createElement('path', {
	                    key: label(stack) + '.' + index,
	                    className: 'dot',
	                    d: symbol(),
	                    transform: translate,
	                    fill: colorScale(label(stack)),
	                    onMouseOver: function onMouseOver(evt) {
	                        return onMouseEnter(evt, e);
	                    },
	                    onMouseLeave: function onMouseLeave(evt) {
	                        return _onMouseLeave(evt);
	                    }
	                });
	            });
	        });
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            circles
	        );
	    }
	});
	
	var ScatterPlot = (0, _createReactClass2.default)({
	    displayName: 'ScatterPlot',
	
	    mixins: [_DefaultPropsMixin2.default, _HeightWidthMixin2.default, _ArrayifyMixin2.default, _AccessorMixin2.default, _DefaultScalesMixin2.default, _TooltipMixin2.default],
	
	    propTypes: {
	        rScale: func,
	        shape: string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            rScale: null,
	            shape: 'circle'
	        };
	    },
	    _tooltipHtml: function _tooltipHtml(d) {
	        var html = this.props.tooltipHtml(this.props.x(d), this.props.y(d));
	
	        var xPos = this._xScale(this.props.x(d));
	        var yPos = this._yScale(this.props.y(d));
	
	        return [html, xPos, yPos];
	    },
	    render: function render() {
	        var _props2 = this.props,
	            height = _props2.height,
	            width = _props2.width,
	            margin = _props2.margin,
	            viewBox = _props2.viewBox,
	            preserveAspectRatio = _props2.preserveAspectRatio,
	            colorScale = _props2.colorScale,
	            rScale = _props2.rScale,
	            shape = _props2.shape,
	            label = _props2.label,
	            values = _props2.values,
	            x = _props2.x,
	            y = _props2.y,
	            xAxis = _props2.xAxis,
	            yAxis = _props2.yAxis;
	
	
	        var data = this._data;
	        var innerWidth = this._innerWidth;
	        var innerHeight = this._innerHeight;
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	        var xIntercept = this._xIntercept;
	        var yIntercept = this._yIntercept;
	
	        var symbol = _d2.default.svg.symbol().type(shape);
	
	        if (rScale) {
	            symbol = symbol.size(rScale);
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                { height: height, width: width, margin: margin, viewBox: viewBox, preserveAspectRatio: preserveAspectRatio },
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'x axis',
	                    orientation: 'bottom',
	                    scale: xScale,
	                    height: innerHeight,
	                    width: innerWidth,
	                    zero: yIntercept
	                }, xAxis)),
	                _react2.default.createElement(_Axis2.default, _extends({
	                    className: 'y axis',
	                    orientation: 'left',
	                    scale: yScale,
	                    height: innerHeight,
	                    width: innerWidth,
	                    zero: xIntercept
	                }, yAxis)),
	                _react2.default.createElement(DataSet, {
	                    data: data,
	                    xScale: xScale,
	                    yScale: yScale,
	                    colorScale: colorScale,
	                    symbol: symbol,
	                    label: label,
	                    values: values,
	                    x: x,
	                    y: y,
	                    onMouseEnter: this.onMouseEnter,
	                    onMouseLeave: this.onMouseLeave
	                }),
	                this.props.children
	            ),
	            _react2.default.createElement(_Tooltip2.default, this.state.tooltip)
	        );
	    }
	});
	
	exports.default = ScatterPlot;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(3);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Chart = __webpack_require__(5);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Bar = __webpack_require__(21);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _DefaultPropsMixin = __webpack_require__(8);
	
	var _DefaultPropsMixin2 = _interopRequireDefault(_DefaultPropsMixin);
	
	var _HeightWidthMixin = __webpack_require__(6);
	
	var _HeightWidthMixin2 = _interopRequireDefault(_HeightWidthMixin);
	
	var _ArrayifyMixin = __webpack_require__(10);
	
	var _ArrayifyMixin2 = _interopRequireDefault(_ArrayifyMixin);
	
	var _StackAccessorMixin = __webpack_require__(16);
	
	var _StackAccessorMixin2 = _interopRequireDefault(_StackAccessorMixin);
	
	var _StackDataMixin = __webpack_require__(17);
	
	var _StackDataMixin2 = _interopRequireDefault(_StackDataMixin);
	
	var _DefaultScalesMixin = __webpack_require__(12);
	
	var _DefaultScalesMixin2 = _interopRequireDefault(_DefaultScalesMixin);
	
	var _TooltipMixin = __webpack_require__(9);
	
	var _TooltipMixin2 = _interopRequireDefault(_TooltipMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var array = _propTypes2.default.array,
	    func = _propTypes2.default.func;
	
	// receive array and return a subsampled array of size n
	//
	// a= the array;
	// n= number of sample you want output
	
	var subSample = function subSample(a, n) {
	    var returnArray = [];
	    var m = a.length;
	    var samplingRatio = m / n;
	
	    //just round down for now in case of comma separated
	    for (var i = 0; i < m;) {
	        returnArray.push(a[Math.floor(i)]);
	        i += samplingRatio;
	    }
	    return returnArray;
	};
	
	var DataSet = (0, _createReactClass2.default)({
	    displayName: 'DataSet',
	
	    propTypes: {
	        data: array.isRequired,
	        xScale: func.isRequired,
	        yScale: func.isRequired,
	        colorScale: func.isRequired,
	        values: func.isRequired,
	        label: func.isRequired,
	        x: func.isRequired,
	        y: func.isRequired,
	        y0: func.isRequired
	    },
	
	    render: function render() {
	        var _props = this.props,
	            data = _props.data,
	            yScale = _props.yScale,
	            colorScale = _props.colorScale,
	            values = _props.values,
	            label = _props.label,
	            y = _props.y,
	            x0 = _props.x0,
	            onMouseEnter = _props.onMouseEnter,
	            onMouseLeave = _props.onMouseLeave;
	
	
	        var height = yScale(yScale.domain()[0]);
	        var bars = data.map(function (stack) {
	            return values(stack).map(function (e, index) {
	                // maps the range [0,1] to the range [0, yDomain]
	                var yValue = height * y(e);
	                // center vertically to have upper and lower part of the waveform
	                var vy = height / 2 - yValue / 2;
	                //position x(e) * width * 2 because we want equal sapce.
	                var vx = 2 * x0 * index;
	
	                return _react2.default.createElement(_Bar2.default, {
	                    key: label(stack) + '.' + index,
	                    width: x0,
	                    height: yValue,
	                    x: vx,
	                    y: vy,
	                    fill: colorScale(Math.floor(vx)),
	                    data: e,
	                    onMouseEnter: onMouseEnter,
	                    onMouseLeave: onMouseLeave
	                });
	            });
	        });
	
	        return _react2.default.createElement(
	            'g',
	            null,
	            bars
	        );
	    }
	});
	
	var Waveform = (0, _createReactClass2.default)({
	    displayName: 'Waveform',
	
	    mixins: [_DefaultPropsMixin2.default, _HeightWidthMixin2.default, _ArrayifyMixin2.default, _StackAccessorMixin2.default, _StackDataMixin2.default, _DefaultScalesMixin2.default, _TooltipMixin2.default],
	
	    getDefaultProps: function getDefaultProps() {
	        return {};
	    },
	    _tooltipHtml: function _tooltipHtml(d) {
	        var _ref = [this._xScale, this._yScale],
	            xScale = _ref[0],
	            yScale = _ref[1];
	
	
	        var html = this.props.tooltipHtml(this.props.x(d), this.props.y0(d), this.props.y(d));
	
	        var midPoint = xScale.rangeBand() / 2;
	        var xPos = midPoint + xScale(this.props.x(d));
	
	        var topStack = this._data[this._data.length - 1].values;
	        var topElement = null;
	
	        // TODO: this might not scale if dataset is huge.
	        // consider pre-computing yPos for each X
	        for (var i = 0; i < topStack.length; i++) {
	            if (this.props.x(topStack[i]) === this.props.x(d)) {
	                topElement = topStack[i];
	                break;
	            }
	        }
	        var yPos = yScale(this.props.y0(topElement) + this.props.y(topElement));
	
	        return [html, xPos, yPos];
	    },
	    render: function render() {
	        var _props2 = this.props,
	            height = _props2.height,
	            width = _props2.width,
	            margin = _props2.margin,
	            colorScale = _props2.colorScale,
	            values = _props2.values,
	            label = _props2.label,
	            y = _props2.y,
	            y0 = _props2.y0,
	            x = _props2.x;
	
	
	        var data = this._data;
	        var innerWidth = this._innerWidth;
	        var xScale = this._xScale;
	        var yScale = this._yScale;
	
	        var preserveAspectRatio = 'none';
	        var viewBox = '0 0 ' + width + ' ' + height;
	
	        // there are two options, if the samples are less than the space available
	        // we'll stretch the width of bar and inbetween spaces.
	        // Otherwise we just subSample the dataArray.
	        var barWidth = void 0;
	        if (data[0].values.length > innerWidth / 2) {
	            data[0].values = subSample(data[0].values, innerWidth / 2);
	            barWidth = 1;
	        } else {
	            barWidth = innerWidth / 2 / data[0].values.length;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _Chart2.default,
	                {
	                    height: height,
	                    width: width,
	                    margin: margin,
	                    viewBox: viewBox,
	                    preserveAspectRatio: preserveAspectRatio
	                },
	                _react2.default.createElement(
	                    DataSet,
	                    {
	                        data: data,
	                        xScale: xScale,
	                        yScale: yScale,
	                        colorScale: colorScale,
	                        label: label,
	                        values: values,
	                        x: x,
	                        y: y,
	                        y0: y0,
	                        x0: barWidth,
	                        onMouseEnter: this.onMouseEnter,
	                        onMouseLeave: this.onMouseLeave
	                    },
	                    this.props.children
	                )
	            )
	        );
	    }
	});
	
	exports.default = Waveform;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(23);
	
	var emptyObject = __webpack_require__(33);
	var _invariant = __webpack_require__(14);
	
	if (process.env.NODE_ENV !== 'production') {
	  var warning = __webpack_require__(19);
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (process.env.NODE_ENV !== 'production') {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (process.env.NODE_ENV !== 'production') {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (process.env.NODE_ENV !== 'production') {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (process.env.NODE_ENV !== 'production') {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (process.env.NODE_ENV !== 'production') {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (process.env.NODE_ENV !== 'production') {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (process.env.NODE_ENV !== 'production') {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(14);
	  var warning = __webpack_require__(19);
	  var ReactPropTypesSecret = __webpack_require__(20);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(14);
	var ReactPropTypesSecret = __webpack_require__(20);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(19);
	var assign = __webpack_require__(23);
	
	var ReactPropTypesSecret = __webpack_require__(20);
	var checkPropTypes = __webpack_require__(34);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// react-d3-components.min.js